import jwtDecode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import apiClient from 'service/service';
import Page404 from 'views/404Page/Page404';
import { SetLeaveAccountModel } from 'views/Leave/SetLeaveAccountModel';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';

const PrivateContainer = ({ children, roles }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [open, setOpen] = useState(true);
    const [childrens, setChildrens] = useState(true);
    const [userDetails, setUserDeatils] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    let newChildrenComponent;

    useEffect(() => {
        checkAuth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAuth = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('accessToken');
            if (token) {
                const user = jwtDecode(token);
                const { data } = await apiClient().get(`/user/${user?._id}`);
                setUserDeatils(data?.user);
                if (!data?.user?.company?.configured && data?.user?.owner) {
                    setChildrens(false);
                } else {
                    setChildrens(true);
                }
                if (roles.includes(data?.user?.role)) {
                    setIsAuthenticated(true);
                }
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.log('Error while authenticating user');
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, [1500]);
        }
    };
    if (!childrens) {
        newChildrenComponent = (
            <SetLeaveAccountModel open={open} user={userDetails} setOpen={setOpen}>
                {children}
            </SetLeaveAccountModel>
        );
    } else {
        newChildrenComponent = children;
    }

    if (loading) {
        return (
            <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                <CircularProgress
                    sx={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        color: '#673AB7',
                        width: '100%',
                        height: '100%',
                        zIndex: '100'
                    }}
                />
            </div>
        );
    }

    return isAuthenticated ? newChildrenComponent : <Page404 />;
};

export default PrivateContainer;

PrivateContainer.propTypes = {
    children: PropTypes.any,
    roles: PropTypes.arrayOf(PropTypes.string)
};
